import $ from "jquery";

/*
 * jQuery plugin : ComboToList
 * Description : Transform combobox to list html
 * Original author: Guillaume DIAS COELHO
 * Copyright Fnac 2014
 */

  // Create the defaults once
  var pluginName = "comboToList",
      defaults = {
        onChange: "",
        hiddenInputName: "",
        breakPoint: -1,
        dataInclude: {},
        arrowClass: "",
        onGenerateHTML: function () { }
      },
      previous = null;

  // The actual plugin constructor
  function Plugin(element, options) {

    this.element = element;
    this.parent = $(this.element).parent();
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  Plugin.prototype = {

    init: function() {
      this.generateHTML();
      this.bindEvents();
    },
    generateHTML: function () {
      this.parent.prepend('<div class="blur-box vHidden" tabindex="-1">&nbsp;</div><div class="focus-box" tabindex="0">&nbsp;</div><div class="fake-box"></div>').find(".fake-box").append("<a><span>" + $("option", this.element).eq(0).text() + "</span><i " + ((this.options.arrowClass != "") ? "class='" + this.options.arrowClass + "'" : "") + "><!-- --></i></a><ul class='contain'></ul>")
      $(".fake-box.toDel").remove();
      var parent = this.parent;
      var options = this.options;
      var goodies = false;
      let index = 0;

      $("option", this.element).each(function (i) {

        var labelTxt = ["Gadget et Goodies"];
        for (let x = 0; x < labelTxt.length; x++) {
          if ($(this).text() === labelTxt[x]) {
            goodies = true;
            return;
          }
        }

        // FUNCTION ESCAPE SPECIAL HTML CHARATER
        var entityMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
          '/': '&#x2F;',
          '`': '&#x60;',
          '=': '&#x3D;'
        };
        function escapeHtml (string) {
          return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
            return entityMap[s];
          });
        }
        // / ESCAPE SPECIAL HTML CHARATER

        var valueOptionEscape = escapeHtml( $(this).val() );
        var valueOption = ($(this).val()) ? "data-value='" + valueOptionEscape + "'" : "";
        var urlOption = ($(this).data("url")) ? "data-url='" + $(this).data("url") + "'" : "";
        var statusOption = ($(this).data("status")) ? "data-status='" + $(this).data("status") + "'" : "";

        var liGenerate = "<li " + valueOption + urlOption + statusOption + ">" + $(this).text() + "</li>";

        parent.find("ul").append(liGenerate);


        if ($(this).prop("selected")) {
          if (goodies === true) {
            index = i - 1;
          } else {
            index = i;
          }
        }


        var optionTag = $(this);

        for (x in options.dataInclude) {
          var paramInclude = options.dataInclude[x];
          var liGenerated = parent.find("ul").find("li").eq(i);

          if (paramInclude.out.element) {
            var tagToAdd = "<" + paramInclude.out.element + ">"
            parent.find("ul").find("li").eq(i).append(tagToAdd);
          }

          var type = paramInclude.data;
          var dataResult = optionTag.data(type);

          if (paramInclude.out.addData)
            liGenerated.data(type, dataResult); // ajout des data-type

          if (paramInclude.out.addCss) {

            var newClass = (!paramInclude.base_css ? "option_css" : paramInclude.base_css) + "_" + type + "_" + dataResult;

            if (paramInclude.out.addCss && paramInclude.out.element) {// add in out.element
              liGenerated.find(paramInclude.out.element).addClass(newClass);
            } else if (paramInclude.out.addCss && !paramInclude.out.element) {
              liGenerated.addClass(newClass);
            }
          }

        }


      });

      this.parent.find("ul").addClass("hide");

      $(this.element).css("display", "none");

      $(".fake-box a span", this.parent).text($(".fake-box li", this.parent).eq(index).text());

      $(".blur-box, .focus-box", this.parent).css({
        "position": "absolute",
        "left": "-999em"
      });

      $(".fake-box").css("position", "relative");
      $("ul", ".fake-box").css('position', 'absolute')

      if (this.options.onGenerateHTML)
        this.options.onGenerateHTML.call(this.parent);
    },
    bindEvents: function () {
      var opts, obj, fakeBox, close, toggle, select, keydown;

      opts = this.options;
      obj = this;
      fakeBox = $('.fake-box', this.parent);

      close = function (e) {
        if (e) e.stopPropagation();
        $(this).removeClass('actived').find("ul").addClass("hide").parent().parent().removeClass("selectActive");;
      };

      toggle = function (e) {
        if (e) e.stopPropagation();

        var active = $(this).hasClass('actived');

        if (previous && previous != this) close.call(previous, e);

        previous = function () { return active ? null : this }.call(this);

        $(this)[(active ? 'remove' : 'add') + 'Class']('actived').find("ul")[(!active ? 'remove' : 'add') + 'Class']("hide").parent().parent().toggleClass("selectActive");

        if (opts.breakPoint > 0) {
          if ($(window).width() <= opts.breakPoint) {
            // call select element
            $(obj.element).change();
            return false;
          }
        }

        obj.controlPosition();

        if (!active) {
          $('ul > li.hovered', this).removeClass('hovered');
          var active_text = $("a span", this).text();
          $('ul > li, this').filter(function () {
            return $(this).text() === active_text;
          }).addClass('hovered');

          $('.blur-box', $(this).parent()).focus();
        }
      };

      $(this.element).prev().click(function (e) {
        toggle.call(this, e);
      });
      $(document).on('click touchend', function (e) {
        close.call(fakeBox);
      });
      $(this.element).prev().on('touchend', function (e) {
        e.preventDefault();
        toggle.call(this, e);
      });

      $(".fake-box span", this.parent).click(function (e) { e.preventDefault(); });

      var select = function (e) {
        e.preventDefault();

        var val = $(this).data("value");
        var txt = $(this).text();
        var $fakeBox = $(this).parents('.fake-box');

        // select option
        $("option:eq(" + $(this).index() + ")", obj.element).prop('selected', true);

        // replace search input text
        $("a span", $fakeBox).text(txt);

        // blur fakebox
        $fakeBox.blur();

        if (!$("[name='" + opts.hiddenInputName + "']").length) {
          $(obj.parent).append("<input type='hidden' name='" + opts.hiddenInputName + "' value='" + val + "' />");
        } else {
          $("[name='" + opts.hiddenInputName + "']").val(val);
        }

        // contrôle la méthode d'envoi de la valeur sélectionnée
        if (typeof opts.onChange == 'function') {
          opts.onChange.call(this, val);
        }

        if (opts.onGenerateHTML) {
          opts.onGenerateHTML.call(obj.parent);
        }
      };

      $(".fake-box li", this.parent).on('click touchend', select);

      var keydown = function (e) {
        var selected = $('.fake-box ul > li.hovered', this);

        var hover = function (reverse) {
          var tohover = (function () {
            if (selected.length > 0) {
              selected.removeClass('hovered');
              var tohover = reverse ? selected.prev() : selected.next();
              if (tohover.length > 0) return tohover;
            }

            return $('.fake-box ul > li:' + (reverse ? 'last' : 'first'), this);
          }).call(this);

          tohover.addClass('hovered');

          e.preventDefault();
          e.stopPropagation();
        };

        if (e) switch (e.keyCode) {
          case 27: //esc
            close.call(fakeBox);
            break;

          case 37:
          case 38: // up
            hover.call(this, true);
            break;

          case 39:
          case 40: // down
            if (!fakeBox.hasClass('actived')) {
              toggle.call(fakeBox, e);

              e.preventDefault();
              e.stopPropagation();
            }
            else hover.call(this);
            break;

          case 13: // enter
          case 9: // tab
            var canSelect = fakeBox.hasClass('actived') && (selected.length > 0);

            if (canSelect)
              select.call(selected);

            if (canSelect || e.keyCode == 13) {
              toggle.call(fakeBox, e);

              e.preventDefault();
              e.stopPropagation();
            }
            break;
        }
      }

      $(this.parent).keydown(keydown);

    },
    controlPosition: function () {
      var positionFakebox, bWindowPos, ulH, aH, ULposition, ULheight, $ul;

      positionFakebox = $(this.parent).offset();
      bWindowPos = (window.scrollY + $(window).height());

      ulH = $("ul", this.parent).outerHeight();
      aH = $(this.element).prev().find("a").outerHeight() + 1;

      ULposition = ((positionFakebox.top + ulH + aH) > bWindowPos) && ($(window).height() > ulH) ? -ulH : aH;

      if (ULposition + positionFakebox.top < 0) ULposition = aH;

      $ul = $(this.element).prev().find("ul");
      $ul.css('top', ULposition + 'px');

    }
  };

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName,
        new Plugin(this, options));
      }
    });
  }
